export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  REPLY_BOX_COLLAPSED: 'replyBoxCollapsed',
};
